var _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSizeDrawing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    viewBox: "0 0 54.380447 39.141575",
    height: "39.141575mm",
    width: "54.380447mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3725"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop3721",
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop3723",
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-54.050595,-78.467858)",
    gradientUnits: "userSpaceOnUse",
    y2: 112.35863,
    x2: 91.470238,
    y1: 100.98399,
    x1: 90.069824,
    id: "linearGradient3727",
    xlinkHref: "#linearGradient3725"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.11736423,-0.06548906)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3713",
    d: "M -0.0621523,39.086845 36.019235,22.51613",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "0.26458332px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3715",
    d: "M 54.193565,33.741445 36.019233,22.51613",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "0.26458332px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3717",
    d: "M 36.019233,0.06548906 V 22.51613",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "0.26458332px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3719",
    d: "M 36.019233,22.516131 -0.0621523,39.086845 54.193565,33.741445 Z",
    style: {
      opacity: 0.203,
      fill: "url(#linearGradient3727)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.26458332px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeDrawing);
export default __webpack_public_path__ + "static/media/size-drawing.746f2625.svg";
export { ForwardRef as ReactComponent };